export const ColorBands = {
	rgb: {
		value: 'rgb',
		label: 'RGB',
		bands: 3,
		values: [
			{ value: '012', label: 'RGB', r: 'R', g: 'G', b: 'B' },
			{ value: '021', label: 'RBG', r: 'R', g: 'B', b: 'G' },
			{ value: '102', label: 'GRB', r: 'G', g: 'R', b: 'B' },
			{ value: '120', label: 'GBR', r: 'G', g: 'B', b: 'R' },
			{ value: '201', label: 'BRG', r: 'B', g: 'R', b: 'G' },
			{ value: '210', label: 'BGR', r: 'B', g: 'G', b: 'R' },
		],
	},
	sentinal2A: {
		value: 'sentinal2A',
		label: 'Sentinal - 2A',
		bands: 13,
		values: [
			{ value: 'sentinal-rgb', label: 'True Colour', r: '4', g: '3', b: '2' },
			{
				value: 'sentinal-vegetation',
				label: 'False Colour - Vegetation',
				r: '8A',
				g: '4',
				b: '3',
			},
			{
				value: 'sentinal-geology',
				label: 'False Colour - Geology',
				r: '12',
				g: '8A',
				b: '2',
			},
		],
	},
	aster: {
		value: 'aster',
		label: 'Aster',
		bands: 14,
		values: [
			{
				value: 'aster-vegetation',
				label: 'False Colour - Vegetation',
				r: '3N',
				g: '2',
				b: '1',
			},
			{
				value: 'aster-geology',
				label: 'False Colour - Geology',
				r: '7',
				g: '4',
				b: '2',
			},
		],
	},
};

export const BlendModes = [
	{ label: 'Normal', value: 1 },
	{ label: 'Multiply', value: 2 },
	{ label: 'Add', value: 3 },
	{ label: 'Difference', value: 4 },
];

export const ImageStretchTypes = [
	{
		label: 'No Stretch',
		value: 'no',
	},
	{
		label: 'Linear - MinMax',
		value: 'minmax',
	},
	{
		label: 'Linear - Percent Clip',
		value: 'percent',
	},
	{
		label: 'Linear - Standard Deviation',
		value: 'standard',
	},
];

export const ImageProperties: any = {
	visible: true,
	transparency: 1.0,
	grayscale: false,
	contrast: 0.5,
	brightness: 0.5,
	gamma: 1.0,
	blendMode: 1,
	blendMakeColorTransparent: false,
	blendInvertSelection: false,
	blendTransparentColor: [1.0, 1.0, 1.0],
	blendSelectionTolerance: 0.5,
	blendOutputTransparency: 0.5,
	blendOutputColor: [1.0, 0.51, 0, 1.0],
	bands: [0, 1, 2, 3],
};
